(function() {
    'use strict';

    function cloneBcr(bcr) {
        return {
            top: bcr.top,
            left: bcr.left,
            bottom: bcr.bottom,
            right: bcr.right,
            width: bcr.width,
            height: bcr.height
        };
    }

    angular.module('GorillaBoy.DocumentViewer')
    .directive('square', function() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                color: '='
            },
            template: '<div class="annotation-square" ng-style="{\'background-color\':color}"></div>'
        };
    })
    .directive("feedbackClientRectFetcher", ['$q', '$timeout', '$rootScope', 'SignalProvider', 'DocumentStateService', function($q, $timeout, $rootScope, SignalProvider, DocumentStateService) {
        return {
            restrict : 'A',
            link : linkFn
        };
        function linkFn($scope, $element, $attrs) {
            var docRightPanelScope = $scope.$parent;
            var raf = null;
            var DRAFTS_PENDING_CONTAINER_HEIGHT = 40,
                SHOWING_FEEDBACK_COMPONENT_BOTTOM_EDGE_POSITION = 140;
            function onFeedbackPanelScroll() {
                raf = null;
                //If there's no selected annotation, then do not trigger $digest() loops
                if (!DocumentStateService.feedback.selectedFeedback) {
                    return;
                }
                $rootScope.$evalAsync(function() {
                    docRightPanelScope.$broadcast(SignalProvider.FeedbackDrawn.FeedbackPanelScrolled, {});
                });
            }
            function attachListenerOnFeedbackEl() {
                $timeout(function() {
                    //After the digest loop you can query for #feedback element
                    $element.find("#feedback").on('scroll', function() {
                        if (raf) {
                            return;
                        }
                        window.requestAnimationFrame(onFeedbackPanelScroll);
                    });
                });
            }
            $scope.$watch('!layout.showFilterPanel', function(newVal, oldVal) {
                //Whenever the #feedback element is recreated, we need to attach the scroll listener
                if (!newVal) {
                    return;
                }
                attachListenerOnFeedbackEl();
            });
            docRightPanelScope.getAnnotationClientRect = function(annotationId, scrollAnnotationIntoView) {
                var $annotationEl = $element.find("#annotation-" + annotationId);
                var $scrollWrapper = $annotationEl.parents(".scrollWrapper");
                return $q(function(resolve, reject) {
                    var annotationEl = $annotationEl.get(0);
                    if (!annotationEl) {
                        reject();
                        return;
                    }
                    if (scrollAnnotationIntoView) {
                        var boundingClientRect = annotationEl.getBoundingClientRect();
                        var wrapperBoundingClientRect = $scrollWrapper.get(0).getBoundingClientRect();
                        if (boundingClientRect.top > $scrollWrapper.height() - $annotationEl.height()) {
                            // scroll 40px more to avoid ".drafts-pending-container"
                            $scrollWrapper.scrollTop($scrollWrapper.scrollTop() + (boundingClientRect.top - wrapperBoundingClientRect.top) - DRAFTS_PENDING_CONTAINER_HEIGHT);
                        } else if ($scope.documentState.selectedPerson && boundingClientRect.top < SHOWING_FEEDBACK_COMPONENT_BOTTOM_EDGE_POSITION) {
                            //140px is the boundingClientRect().bottom value of the "Showing XYZ Feedback" div.
                            //If this is the first annotation for the page and there's a filtering by user then push the scrollbar up by 200px
                            $scrollWrapper.scrollTop($scrollWrapper.scrollTop() - (wrapperBoundingClientRect.top - boundingClientRect.top) - 200);
                        } else if (boundingClientRect.top < 60) {
                            //If this is the first annotation for the page then push the scrollbar up by 100px
                            $scrollWrapper.scrollTop($scrollWrapper.scrollTop() - (wrapperBoundingClientRect.top - boundingClientRect.top) - 100);
                        }
                        $timeout(resolveWithAnnotationBcr, 0);
                    } else {
                        resolveWithAnnotationBcr();
                    }
                    function resolveWithAnnotationBcr() {
                        var boundingClientRect = annotationEl.getBoundingClientRect();
                        boundingClientRect = cloneBcr(boundingClientRect);
                        //decrement the tab panel headers height. //TODO calculate the header height dynamically
                        boundingClientRect.top = boundingClientRect.top - 50;
                        resolve(boundingClientRect);
                    }
                });
            };
        }
    }])
    .directive('feedbackCommentEntry', [
        'SourceConstant',
        function (SourceConstant) {
            return {
                restrict: 'E',
                templateUrl: './document-viewer/feedback_comment_entry.html'
            };
        }
    ])
    .directive('feedbackAnnotationEntry', [
        'SourceConstant',
        function (SourceConstant) {
            return {
                restrict: 'E',
                templateUrl: './document-viewer/feedback_annotation_entry.html'
            };
        }
    ]);
    //Removed unused activeColor directive
}());
